// extracted by mini-css-extract-plugin
export default {"container":"IJ-z","dimension":"JJ-z","dimensionLabels":"KJ-z"};